// src/helpers/auth-headers.js

import { getAccessTokenFromStorage } from "./token";

export function authHeader() {
  const token = getAccessTokenFromStorage();
  if (token) return { Authorization: `Bearer ${token}` };
  return {};
}
